import React, {useState, useEffect, useRef} from 'react';
import { targetIcon } from "@/lib/icons";
import { getProductLink } from '@/lib/utils';
import useOutsideClick from '@/components/close_modal_outside_click';

function ApplicationPhotoPageImage (props) {
  const [markers, setMarkers]=  useState([]);
  const [triggerRerender, setTriggerRerender] = useState(false);
  const img = useRef();
  const toolTip = useRef();

  useEffect(() => {
    const handleResize = () => (setTriggerRerender((prev) =>  !prev))
    const observer = new MutationObserver((event) => {
      if (event[0] && event[0].attributeName === 'style'){
        handleResize(); 
      }
    })
    const config = {
      attributes: true
    }
    window.addEventListener('resize', handleResize); 
    observer.observe(img?.current, config)
    setMarkers(props.markers.map((d) => { return {...d, _id: genId() } } ))
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [props.markers]);

  useOutsideClick(toolTip, () => {
    props.updateClickId('');
  });

  const genId = () => ( Math.random().toString(16).slice(2) );

  const renderScaleFactor = () => {
    return img.current.clientWidth / props.app_photo.width;
  }

  const renderMarker = (marker) => {
    let scaling = renderScaleFactor();
    let offset = 1;
    let x = (marker.x - offset) * scaling; 
    let y = (marker.y - offset) * scaling;
    let markerClassName = 'marker-container';
    if(props.hoverId == marker.data.product_id && props.clickedId != marker.data.product_id)
      markerClassName += ' marker-container-hover';
    else if(props.clickedId == marker.data.product_id)
      markerClassName += ' marker-container-clicked';
    else 
      markerClassName = 'marker-container'
    return (
      <div key={marker.id } 
        id={marker.id}
        style={{display: (marker._destroy ? 'none' : 'flex'), top: `${y}px`, left: `${x}px`}} 
        className={markerClassName}
        onMouseEnter={() => props.updateHoverId(marker.data.product_id)}
        onMouseLeave={() => props.updateHoverId('')}
        onClick={() => setTimeout(()=> { 
          if(props.clickedId != marker.data.product_id) 
            props.updateClickId(marker.data.product_id)
          else
            props.updateClickId('')
        })}>
        <div className='marker'>
          { targetIcon }
          { marker.clicked && 
            <a rel='noreferrer noopener' className='hot-spot-tool-tip' href={getProductLink({ slug: marker.data.product_slug })} ref={toolTip}>
              <img alt={marker.data.product_name} src={marker.data.product_image_path} className='hot-spot-product-image' height='75px' />
              <div className='hot-spot-product-details'>
                <div className='product-manufacturer-container'>
                  <p className='hot-spot-product-name'>{marker.data.product_name}</p>
                  <p className='hot-spot-manufacturer-name'>{marker.data.manufacturer_name}</p>
                </div>
                <p className='hot-spot-view-product'>View Product</p>
              </div>
            </a>
          }
        </div>
     </div>
    )
  }

  return (
    <div className='lexcms-application-photo-page-image'>
      <div style={{position: 'relative'}}> 
        {img.current && markers.map((d, i) => {
          return (renderMarker(d) )
        })
        }
        <img ref={img} src={props.app_photo.image_url} style={{width: '100%'}} />
      </div>
    </div>
  ); 
}

export default ApplicationPhotoPageImage;
